import { Block } from '@xprog/prensa'
import { Input, Label } from 'components/Input/Input.styles'
import React from 'react'

const InputEdital = ({ ...otherProps }) => {
  return (
    <Block css={{ align: ['column', 'left', 'top'] }}>
      <Label
        css={{
          fontFamily: '$primary',
          fontSize: '16px',
          fontWeight: '500',
          ml: '$3',
          mb: '$1'
        }}
      >
        CNPJ
      </Label>
      <Input
        maxLength={18}
        css={{
          borderColor: '#BFBFBF',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderRadius: '$unset',
          color: '#4D4D4D',
          fontFamily: '$primary',
          fontSize: '16px',
          px: '$3',
          height: '40px',
          mb: '$4',
          width: '100%'
        }}
        {...otherProps}
      />
    </Block>
  )
}

export default InputEdital